"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLeverageButton = useLeverageButton;
var _react = require("react");
var _reactRedux = require("react-redux");
var _actions = require("../../../../redux/margin/actions");
var _modalActions = require("../../../../redux/actions/modalActions");
var _selectors = require("../../../../redux/margin/selectors");
var _instrumentPositionSelectors = require("../../../../redux/selectors/instrumentPositionSelectors");
var _hooks = require("../../hooks");
function useLeverageButton(formName) {
  var instrumentId = (0, _reactRedux.useSelector)(_instrumentPositionSelectors.selectedInstrumentIdSelector);
  var formValues = (0, _hooks.useFormValues)(formName);
  var price = (0, _hooks.useOrderPrice)(formName);
  var leverage = (0, _reactRedux.useSelector)(_selectors.currentLeverageSelector);
  var equityData = (0, _reactRedux.useSelector)(_selectors.marginAccountEquitySelector);
  var max = (0, _reactRedux.useSelector)(_selectors.maxLeverageSelector);
  var noLeverage = equityData.IsLeverageAllowed === false || !leverage;
  var disabled = max <= 2 || leverage <= 1 || noLeverage;
  var dispatch = (0, _reactRedux.useDispatch)();
  var equityPayload = (0, _react.useMemo)(function () {
    return {
      price: price,
      leverage: leverage,
      instrumentId: instrumentId,
      side: formValues.side,
      orderType: formValues.orderType
    };
  }, [formValues.side, formValues.orderType, leverage, instrumentId, price]);
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.getMarginAccountEquity)(equityPayload));
  }, [equityPayload, dispatch]);
  var onClick = (0, _react.useCallback)(function () {
    dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.UPDATE_LEVERAGE, {
      formName: formName
    }));
  }, [dispatch, formName]);
  return {
    leverage: leverage,
    noLeverage: noLeverage,
    disabled: disabled,
    onClick: onClick
  };
}